export default __webpack_public_path__ + "static/media/downArrowRed.a6fcf6d0.svg";